// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { Box, } from '@mui/material';

// TODO: Import MUI icon

// TODO: Import context
import { Context } from '../Common/Context';
import { Text } from '../Common/Text';

// TODO: Import custom component
import BoxSubPage from '../Common/BoxSubPage';
import ListText from '../Common/ListText';
import { ContentTitle, MultipleRows } from '../Common/TypographyTYH';

import Slide from './Slide_Achievements.jpg';


const DSEResult2026 = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component DSEResult2026 Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define variable

    // TODO: Define event

    // TODO: Return component
    return (
        <BoxSubPage
            disableMenu={true}
            id="DSEResult2026"
            image={Slide}
            title={Text.Achievements.DSEResult2026.Title[context.language]}
        >
            {/*<ContentTitle text="最佳五科成績（首三名）" />
            <MultipleRows
                rows={[
                    '陳迪凱	5**, 5**, 5*, 5, 5',
                    '郭浚傑	5 **, 5, 5, 5, 4',
                    '張凱鎣	5 *, 5, 4, 4, 3',
                ]}
                sx={{ mb: 0 }}
            />
            <ContentTitle sx={{ mt: 2 }} text="考獲5**、5*或5優異成績的科目包括" />
            <MultipleRows
                rows={['中文、數學、化學、物理、生物、資通、地理、經濟、企概、旅款']}
                sx={{ mb: 0 }}
            />
            <ContentTitle sx={{ mt: 2 }} text="考獲5**成績高於全港水平的科目包括" />
            <MultipleRows
                rows={['化學、物理']}
                sx={{ mb: 0 }}
            />
            <ContentTitle sx={{ mt: 2 }} text="考獲5*成績高於全港水平的科目包括" />
            <MultipleRows
                rows={['化學、地理']}
                sx={{ mb: 0 }}
            />
            <ContentTitle sx={{ mt: 2 }} text="考獲4級至5**成績的科目包括" />
            <MultipleRows
                rows={['中文、英文、數學、化學、物理、生物、資通、地理、中史、經濟、企概、旅款、視藝、體育']}
                sx={{ mb: 0 }}
            />
            <ContentTitle sx={{ mt: 2 }} text="考獲4級或以上成績高於全港水平的科目包括" />
            <MultipleRows
                rows={['化學、生物、地理、經濟、企概、旅款']}
                sx={{ mb: 0 }}
            />
            <ContentTitle sx={{ mt: 2 }} text="考獲3級或以上成績高於全港水平的科目包括" />
            <MultipleRows
                rows={['數延、化學、生物、地理、經濟、企概、旅款、體育']}
                sx={{ mb: 0 }}
            />
            <ContentTitle sx={{ mt: 2 }} text="合格率與全港比較" />
            <ListText lines={[
                '12科2級或以上成績高於全港水平，其中9科達90%或之上',
                '7科合格率達100%，包括：生物、化學、地理、經濟、企概、數延、體育',
                '乙類科目(應用學習)達標及表現優異(I)高於全港水平',
            ]} />*/}
            <ContentTitle sx={{ mt: 2 }} text="成績再創高峰" />
            <ListText lines={[
                '獲大學取錄人數創新高',
                '符合大學或院校入學要求的人數比率歷年最高',
                '符合副學位課程入學要求的人數比率歷年最高',
                '4級或以上優良數目歷年最高',
            ]} />
            <ContentTitle sx={{ mt: 2 }} text="優良率與全港比較" />
            <ListText lines={[
                '考獲5**、5*或5優異成績的科目包括：中、英、化學、生物、企概、中史、地理',
                '考獲4級至5**成績的科目包括：中、英、數、物理、化學、生物、經濟、企概、資通、中史、地理、旅款、視藝、體育',
            ]} />
            <ContentTitle sx={{ mt: 2 }} text="合格率與全港比較" />
            <ListText lines={[
                '所有科目平均合格率高於全港水平，14科考獲2級或以上成績高於全港水平',
                '9科合格率達100%，包括：生物、化學、資通、中史、地理、視藝、企概、數延、體育',
                '乙類科目(應用學習)達標率達100%，達標及表現優異(I)率高於全港水平',
            ]} />
            <ContentTitle sx={{ mt: 2 }} text="本學年考獲優良成績之同學名單" />
            <MultipleRows
                rows={['何兆康、吳朗埄、吳詩韻、李梓銦、李靖昤、李穎琳、孫暉喬、殷嘉智、梁凱怡、許晴晴、陳柏賢、陳榮錄、陳諾一、陳駿希、黃宏華、黃國鋒、黃霈豪、黃穎詩、楊晉傑、葉文棟、鍾傜羽、藍上鈞、顏浩然、羅卓南、孔俊傑、王慧琳、何諾熹、李奕朗、冼楚穎、柯啟濤、梁凱怡、陳宏盛、陳煥榮、鄭卓螢、譚凱鍵、尹頌熙、牛胤權、馬晉煒、莫苡辰']}
                sx={{ mb: 0 }}
            />
            {/*<Box component="img" src="https://www.pohtyh.edu.hk/Files/Achievements/DSEResult2026.jpg" sx={{ width: 1 }} />*/}
        </BoxSubPage>
    );
}
export default DSEResult2026;